export const en = {
  reconnectWith: (integrationName: string) =>
    `Reconnect BugHerd with ${integrationName}`,
  reconnect: 'Reconnect',
  standardChanges:
    'This will simply upgrade my project to use our new & improved integration. No changes will be made to the',
  tasksInBugherd: {
    Jira: '/issues',
    Trello: '/cards',
    Asana: '/issues',
    ClickUp: '',
    Monday: ''
  },
  inBugherd(integrationName: string) {
    return `tasks${this.tasksInBugherd[integrationName]} in BugHerd or ${integrationName}.`;
  },
  impactQuestion: 'How will this impact my project',
  currentlyConnected: (integrationName: string) =>
    `This Project is currently connected to ${integrationName} through our legacy integration. To upgrade to the latest ${integrationName} integration please reconnect your ${integrationName} account.`,
  upgradeSlack: 'Upgrade your Slack integration',
  upgrade: 'Upgrade',
  upgradeChanges:
    'There will be no change to your project. Just a much, much better Slack integration. Promise!'
};

export type Translations = typeof en;
